export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Animated_Gifs_pt-BR.1267db3.vtt";